import { frontendURL } from 'dashboard/helper/URLHelper.js';

const FollowUpsPage = () => import('./pages/FollowUpsPage.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/follow-ups'),
    name: 'follow_ups_index',
    component: FollowUpsPage,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
